import { render, staticRenderFns } from "./UserView.vue?vue&type=template&id=20697f24&scoped=true&"
import script from "./UserView.vue?vue&type=script&lang=ts&"
export * from "./UserView.vue?vue&type=script&lang=ts&"
import style0 from "./UserView.vue?vue&type=style&index=0&id=20697f24&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20697f24",
  null
  
)

export default component.exports